import VisitorTypesPageView from "./VisitorTypesPageView";

function VisitorTypesPage() {
  return <VisitorTypesPageView />;
}

export default VisitorTypesPage;